import { CalendarDays, CircleHelp, MapPin } from "lucide-react";

interface HeaderProps {
  onHome: () => void;
  onEvents: () => void;
  onHelp: () => void;
}

export function Header({ onHome, onEvents, onHelp }: HeaderProps) {
  return (
    <header className="topbar">
      <button className="brand-button" onClick={onHome} aria-label="Zur Startseite">
        <span className="logo-mark"><MapPin size={20} strokeWidth={2.4} /></span>
        <span className="brand-copy">Hofflohmarkt Map<small>Termine · Tourpläne · echte Koordinaten</small></span>
      </button>
      <nav aria-label="Hauptnavigation">
        <button className="nav-link" onClick={onEvents} aria-label="Termine anzeigen"><CalendarDays size={16} /> <span>Termine</span></button>
        <button className="nav-link help-link" onClick={onHelp} aria-label="Hilfe öffnen"><CircleHelp size={16} /> <span>Hilfe</span></button>
      </nav>
    </header>
  );
}
